import { ArrowUpRight, Sparkles } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useBooking } from "@/context/BookingContext";

export const TreatmentRow = ({ service, index }) => {
  const { T, lang } = useLanguage();
  const { openBooking } = useBooking();
  const name = lang === "pt" ? service.name_pt : service.name_fr;
  const desc = lang === "pt" ? service.description_pt : service.description_fr;

  return (
    <div
      className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 items-center py-7 md:py-9 border-b border-[#090708]/8 hover:bg-[#9B6179]/5 transition-colors duration-500 cursor-pointer"
      onClick={() => openBooking(service.id)}
      data-testid={`treatment-card-${service.slug}`}
    >
      <span className="hidden md:block md:col-span-1 font-serif text-sm text-[#E8C47A]">{String(index + 1).padStart(2, "0")}</span>
      <div className="md:col-span-2 h-24 md:h-20 overflow-hidden">
        {service.image_url
          ? <img src={service.image_url} alt={name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
          : <div className="w-full h-full bg-[#F7F0E8] flex items-center justify-center" data-testid={`treatment-placeholder-${service.slug}`}><Sparkles className="w-6 h-6 text-[#9B6179]/40" /></div>}
      </div>
      <div className="md:col-span-6">
        <p className="font-serif text-2xl md:text-3xl text-[#090708] mb-1">{name}</p>
        <p className="text-sm text-[#090708]/55 leading-relaxed max-w-md">{desc}</p>
      </div>
      <div className="md:col-span-1">
        {service.price > 0 && <p className="font-serif text-2xl text-[#9B6179] whitespace-nowrap" data-testid={`treatment-price-${service.slug}`}>{Number(service.price).toLocaleString(lang === "pt" ? "pt-BR" : "fr-FR")} €</p>}
        <span className="text-[11px] tracking-widest uppercase text-[#090708]/40">{T.treatments.duration_label}</span>
      </div>
      <button
        onClick={(e) => { e.stopPropagation(); openBooking(service.id); }}
        data-testid={`treatment-book-button-${service.slug}`}
        className="md:col-span-2 justify-self-start md:justify-self-end inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[#090708] relative after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-full after:h-px after:bg-[#E8C47A] after:scale-x-0 group-hover:after:scale-x-100 after:transition-transform after:duration-300"
      >
        {T.treatments.book} <ArrowUpRight className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
